export const buildProviderSourceColumnHeader = (providerName, t) => (
    `${t('Source')}: ${providerName} ${t('Company Report')}`
);
